import * as moment from "moment";

import {
    ManagerSraQuestionnaireResultModel
} from "@teamprevent/common/stressRiskAssessment/models";

import * as actions from "./actiontypes";
import { CustomerUserAction, SraAction } from "./actions";
import { CustomerUser } from "./model";

export function customerUsers(state: CustomerUser[] = [], action: CustomerUserAction): CustomerUser[] {
    switch (action.type) {
        case actions.SAVE_CUSTOMERUSER_SUCCESS:
        case actions.LOAD_CUSTOMERUSER_DETAIL_SUCCESS:
            return state.map(c => customerUser(c, action));
        case actions.CREATE_CUSTOMERUSER_SUCCESS:
            return [...state, detailUpdated(action.payload)];
        case actions.DELETE_CUSTOMERUSER_SUCCESS:
            return [...state.filter(c => c.id !== action.payload)];
        case actions.ACTIVATE_CUSTOMERUSER_SUCCESS:
            const activatedUser = state.find(user => user.id === action.payload);
            return [...state.filter(c => c.id !== action.payload), { ...activatedUser, active: true }];
        case actions.DEACTIVATE_CUSTOMERUSER_SUCCESS:
            const deactivatedUser = state.find(user => user.id === action.payload);
            return [...state.filter(c => c.id !== action.payload), { ...deactivatedUser, active: false }];
        default:
            return state;
    }
}

export function sraResults(state: ManagerSraQuestionnaireResultModel = null, action: SraAction): ManagerSraQuestionnaireResultModel {
    switch (action.type) {
        case actions.LOAD_SRA_RESULTS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

function customerUser(state: CustomerUser, action: CustomerUserAction): CustomerUser {
    switch (action.type) {
        case actions.SAVE_CUSTOMERUSER_SUCCESS:
            if (action.payload.id === state.id) {
                return detailUpdated(action.payload, state);
            }
            return state;
        case actions.LOAD_CUSTOMERUSER_DETAIL_SUCCESS:
            if (action.payload.id === state.id) {
                return detailUpdated(action.payload, state);
            }
            return state;
        default:
            return state;
    }
}

function detailUpdated(value: CustomerUser, state: CustomerUser = {} as CustomerUser): CustomerUser {
    return { listUpdated: moment(), ...state, ...value, detailUpdated: moment() };
}
